import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import img from "../../../../assets/images/serviceImages/socialMediaStrategy.webp"

const SocialMediaContentWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="flex justify-center items-center"
            pagination={{
              type: "bullets",
              el: ".pagination-progress",
              clickable: true,
            }}
            autoplay={true}
            spaceBetween={20}
            slidesPerView={1}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop
          >
            <SwiperSlide>
              <img
                src={img}
                className="rounded-[16px] w-full"
                alt=""
              />
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination pagination-progress w-full relative z-10 py-5"></div>
        </div>
      </NewCommonServiceContent>
    </div>
  )
}

export default SocialMediaContentWork